export var PS_PILL_TITLES = {
    PS: 'Program Success Dashboard',
    SHERPATH: 'Build Knowledge | Sherpath',
    SHADOW_HEALTH: 'Apply Clinical Judgment | Shadow Health',
    HESI: 'Assess & Review | HESI',
    DP: 'Program Success Dashboard for Program Leaders'
};
export var DEFAULT_SH_DATA = {
    data: [],
    fallbackMessage: ''
};
export var PS_SHERPATH_ASSIGNMENT_SCORE_COLOR = {
    RED: 'u-els-fill-warn',
    GREEN: 'u-els-fill-extended-green-8'
};
export var PS_SHERPATH_ASSIGNMENT_SCORE_THRESHOLD = 65;
export var DP_PILLS = [
    {
        color: 'blue',
        icon: 'Statistics',
        text: PS_PILL_TITLES.HESI,
        iconClass: 'u-els-color-secondary'
    }
];
export var PS_PILLS = [
    {
        color: 'green',
        icon: 'Neuroimagery',
        text: PS_PILL_TITLES.SHERPATH,
        iconClass: 'u-custom-color-green-1'
    },
    {
        color: 'orange',
        icon: 'Stethoscope',
        text: PS_PILL_TITLES.SHADOW_HEALTH,
        iconClass: 'u-custom-color-orange-1'
    },
    {
        color: 'blue',
        icon: 'Statistics',
        text: PS_PILL_TITLES.HESI,
        iconClass: 'u-els-color-secondary'
    }
];
